// extracted by mini-css-extract-plugin
export default {"fragment":"WelcomeBonusNotify_fragment__sfO2E","footerText":"WelcomeBonusNotify_footerText__ALcM6","footerLink":"WelcomeBonusNotify_footerLink__06cMr"};